import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sizeListData: [],
  singleSize:[],
  colorListData:[],
  singleColor:[],
  catagoriesList:[],
  occassionList:[],
  singleOccassion:[],
  brandList:[],
  sinlgeBrand:[],
  singleProduct:[],
  subcategoriesList:[],
  ingredients:[],
  productList: [],
  productCalculation: [],
  cartList:[],
  wishlistList:[],
  singleView:[],
  singleBooking:[],
  singleAddonList: [],
  singleGiftcardList: [],
  MenuListData: [],
  OrderList: [],
  OrderListView: [],
  StatusList:[],
  StatusListView: [],
  subcategoriesCSVList: [],
  DashboardData: [],
  WalletList: [],
  WalletValidityList: [],
  SingleWalletValidity: [],
  CustomerDetails: [],
  CustomerList: [],
  FaqData: [],
  TermAndConditionData: [],
  LoyaltyConfig: null,
  LoyaltyTransactions: { transactions: [], pagination_meta: null },
  LoyaltyUserPoints: null,
  typeList: [],
  singleType: {},
  dynamicSections: [],
  dynamicSectionDetail: null,
  banners: { data: [], pagination: null },
  bannerDetail: null,
  promoPopups: { data: [], pagination: null },
  promoPopupDetail: null,
};

export const reusableSlice = createSlice({
  name: "reusable",
  initialState,
  reducers: {
    setCustomerDetails: (state, action) => {
        state.CustomerDetails = action.payload;
      },
    setTermAndConditionData: (state, action) => {
        state.TermAndConditionData = action.payload;
      },
    setSingleWalletValidity: (state, action) => {
        state.SingleWalletValidity = action.payload;
      },
    setSizeListData: (state, action) => {
      state.sizeListData = action.payload;
    },
    setSingleSize: (state, action) => {
        state.singleSize = action.payload;
      },
      setColorListData: (state, action) => {
        state.colorListData = action.payload;
      },
      setSinlgeColor: (state, action) => {
        state.singleColor = action.payload;
      },
      setCategoriesList: (state, action) => {
        state.catagoriesList = action.payload;
      },
      setOccassionList: (state, action) => {
        state.occassionList = action.payload;
      },
      setSingleOccassion: (state, action) => {
        state.singleOccassion = action.payload;
      },
      setBrandList: (state, action) => {
        state.brandList = action.payload;
      },
      setCartList: (state, action) => {
        state.cartList = action.payload;
      },
      setSingleBrand: (state, action) => {
        state.sinlgeBrand = action.payload;
      },
      setGetSubcategories: (state, action) => {
        state.subcategoriesList = action.payload;
      },
      setGetCSVSubcategories: (state, action) => {
        state.subcategoriesCSVList = action.payload;
      },
      setIngredients: (state, action) => {
        state.ingredients = action.payload;
      },
      setProductList: (state, action) => {
        state.productList = action.payload;
      },
      setSingleProduct: (state, action) => {
        state.singleProduct = action.payload;
      },
      setProductCalculation: (state, action) => {
        state.productCalculation = action.payload;
      },
      setWishList: (state, action) => {
        state.wishlistList = action.payload;
      },
      setSingleView: (state, action) => {
        state.singleView = action.payload;
      },
      setSingleBookingss: (state, action) => {
        state.singleBooking = action.payload;
      },
      setCategoriesAddonList: (state, action) => {
        state.singleAddonList = action.payload;
      },
      setCategoriesGiftcardList: (state, action) => {
        state.singleGiftcardList = action.payload;
      },
      setMenuListData: (state, action) => {
        state.MenuListData = action.payload;
      },
      setOrderList: (state, action) => {
        state.OrderList = action.payload;
      },
      setOrderListView: (state, action) => {
        state.OrderListView = action.payload;
      },
      setStatusList: (state, action) => {
        state.StatusList = action.payload;
      },
      setStatusListView: (state, action) => {
        state.StatusListView = action.payload;
      },
      setDashboardData: (state, action) => {
        state.DashboardData = action.payload;
      },
      setWalletList: (state, action) => {
        state.WalletList = action.payload;
      },
      setWalletValidityList: (state, action) => {
        state.WalletValidityList = action.payload;
      },
      setCustomerList: (state, action) => {
        state.CustomerList = action.payload;
      },
      setFaqData: (state, action) => {
        state.FaqData = action.payload;
      },
      setLoyaltyConfig: (state, action) => {
        state.LoyaltyConfig = action.payload;
      },
      setLoyaltyTransactions: (state, action) => {
        state.LoyaltyTransactions = action.payload;
      },
      setLoyaltyUserPoints: (state, action) => {
        state.LoyaltyUserPoints = action.payload;
      },
      setTypeList: (state, action) => {
        state.typeList = action.payload;
      },
      setSingleType: (state, action) => {
        state.singleType = action.payload;
      },
      setDynamicSections: (state, action) => {
        state.dynamicSections = action.payload;
      },
      setDynamicSectionDetail: (state, action) => {
        state.dynamicSectionDetail = action.payload;
      },
      setBanners: (state, action) => {
        state.banners = action.payload;
      },
      setBannerDetail: (state, action) => {
        state.bannerDetail = action.payload;
      },
      setPromoPopups: (state, action) => {
        state.promoPopups = action.payload;
      },
      setPromoPopupDetail: (state, action) => {
        state.promoPopupDetail = action.payload;
      },

  },
});

export const {
  setTermAndConditionData,
  setCustomerDetails,
  setFaqData,
  setCustomerList,
  setDashboardData,
  setSingleWalletValidity,
  setWalletList,
  setWalletValidityList,
  setGetCSVSubcategories,
  setStatusListView,
  setStatusList,
  setOrderListView,
  setOrderList,
  setMenuListData,
  setCategoriesGiftcardList,
  setSingleBookingss,
  setSingleView,
  setWishList,
  setCartList,
    setSingleProduct,
    setSizeListData,
    setSingleSize,
    setColorListData,
    setSinlgeColor,
    setCategoriesList,
    setCategoriesAddonList,
    setOccassionList,
    setSingleOccassion,
    setBrandList,
    setSingleBrand,
    setProductList,
    setGetSubcategories,
    setIngredients,
    // setProductList,
    setProductCalculation,
    setLoyaltyConfig,
    setLoyaltyTransactions,
    setLoyaltyUserPoints,
    setTypeList,
    setSingleType,
    setDynamicSections,
    setDynamicSectionDetail,
    setBanners,
    setBannerDetail,
    setPromoPopups,
    setPromoPopupDetail,

} = reusableSlice?.actions;
